import {EntityService} from '../../../../../service/EntityService';

export class GroupPermissionService extends EntityService {

  static entity = 'api/app/system-permission';

  static currentTenant(): Promise<any>{
    return this.axios.get(`${this.entity}/system`).then(res => res.data);
  }

  static currentPermission(providerKey: string): Promise<any>{
    return this.axios.get(`${this.entity}/providerName=R&providerKey=${providerKey}`).then(res => res.data);
  }
}
